import React from 'react';
import SortableTree, {
  removeNodeAtPath,
  defaultGetNodeKey,
  getVisibleNodeCount,
  getFlatDataFromTree,
  changeNodeAtPath,
} from 'react-sortable-tree';
import _ from 'lodash';
import { withState, compose } from 'recompose';
import Scroll from 'react-scroll';
import MenuEditor from './MenuEditor';
import MenuAddingDialog from './MenuAddDialog';
import PageContent from 'components/wrappers/PageContent'
import CustomFlatButton from 'components/Button/CustomFlatButton'
import FormInput from 'components/forms/bases/FormInput'
import StateToolBar from 'components/bars/StateToolBar'
import { updateObject } from 'helpers/objectHelpers'
import {
  Paper,
  IconButton,
  RaisedButton,
} from 'material-ui';

const scroll = Scroll.animateScroll;

// data is an array
const MenuController = compose(
  withState('editData', 'updateEditData', {}),
  withState('editing', 'onChangeEditing', false),
  withState('adding', 'onChangeAdding', false),
)(
  ({
    menu,
    menu: {
      name,
      data,
    },

    onChange, // callback that accept new data
    updateEditData,
    editData,
    onChangeEditing,
    editing,
    adding,
    onChangeAdding,
    isStateChanged,
    setIsStateChanged,
    onDiscardChange,
    onSave,
    saveStatus,
  }) => {
    const total = data && data.length > 0 ? getVisibleNodeCount({ treeData: data }) : 0;

    const handleMenuUpdate = (newMenu) => {
      setIsStateChanged(true)
      return onChange(newMenu);
    }

    const handleNameChange = (newName) => handleMenuUpdate(updateObject(menu, { name: newName }))

    const handleTreeUpdate = (newData) => handleMenuUpdate(updateObject(menu, { data: newData }));

    const handleRemove = ({ path }) => {
      handleTreeUpdate(removeNodeAtPath({ treeData: data, path, getNodeKey: defaultGetNodeKey }));
      updateEditData({});
    };

    const handleSelect = ({ treeIndex }) => {
      const flatTree = getFlatDataFromTree({
        treeData: data,
        getNodeKey: defaultGetNodeKey,
      });
      updateEditData(flatTree[treeIndex]);
      onChangeEditing(true);
    };

    const handleEdit = (newNode) => {
      const newTreeData = changeNodeAtPath({
        treeData: data, getNodeKey: defaultGetNodeKey, path: editData.path, newNode,
      });
      updateEditData(updateObject(editData, { node: newNode }));
      handleTreeUpdate(newTreeData);
    };

    const styles = {
      tree: {
        height: 62 * total + 92,
        minHeight: 500,
        paddingTop: '10px',
        width: '100%',
      },
      all: {
        display: 'flex',
        width: '100%',
      },
      button: {
        textAlign: 'right',
        margin: 10,
      },
    };

    if (!data) {
      return null;
    }
    if (editing) {
      _.assign(styles.tree, { width: '50%', marginRight: '10px' });
    }
    return (
      <PageContent>
        <Paper>
          <StateToolBar
            primary={isStateChanged}
            isStateChanged={isStateChanged}
            onDiscard={() => {
              onChangeEditing(false)
              setIsStateChanged(false)
              return onDiscardChange()
            }}
            onSave={onSave}
            saveStatus={saveStatus}
          >
            <RaisedButton
              label="Add Menu"
              primary={!isStateChanged}
              onTouchTap={() => onChangeAdding(!adding)}
            />
          </StateToolBar>
          <div style={styles.all}>
            <div style={styles.tree}>
              <FormInput
                label="Menu Name"
                value={name}
                onChange={handleNameChange}
                style={{ width: '30%', marginLeft: 20 }}
              />
              {
                data.length === 0 &&
                <div
                  style={{
                    minHeight: 500,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#d8d8d8',
                    fontSize: 72,
                  }}
                >
                  Empty Menu
                </div>
              }
              <SortableTree
                treeData={data}
                maxDepth={3}
                onChange={handleTreeUpdate}
                generateNodeProps={(rowInfo) => ({
                  buttons: [
                    <IconButton
                      iconClassName="fa fa-pencil"
                      onClick={() => {
                        scroll.scrollToTop({ delay: 0, duration: 300, smooth: true });
                        return handleSelect(rowInfo);
                      }}
                    />,
                    <IconButton
                      iconClassName="fa fa-trash"
                      onClick={() => handleRemove(rowInfo)}
                    />,
                  ],
                })}
              />
            </div>
            {editing &&
            <div
              style={{
                width: '50%',
                borderLeft: '1px solid #e8e8e8',
                display: 'inline-block',
              }}
            >
              <div style={styles.button}>
                <CustomFlatButton
                  label=">"
                  secondary
                  onClick={() => onChangeEditing(false)}
                />
              </div>
              <MenuEditor
                menu={editData.node}
                onChange={(value) => handleEdit(value)}
              />
            </div>
            }
          </div>
        </Paper>

        <MenuAddingDialog
          open={adding}
          onClose={onChangeAdding}
          onSubmit={(menus) => {
            scroll.scrollToBottom({ delay: 0, duration: 300, smooth: true });
            return handleTreeUpdate([...data, ...menus])
          }}
        />

      </PageContent>
    );
  },
)

MenuController.propTypes = {};
MenuController.defaultProps = {};

export default MenuController



// WEBPACK FOOTER //
// ./src/pages/Menus/children/MenuController.js